
import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogDepartment from '@/components/DeptLev/index.vue';
import { groupCsList, addGroupCs, editGroupCs, delGroupCs, batchAddCheckGroup } from '../../api/group';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '../../types/permissionType';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { GroupType } from '@/types/groupType';


@Component({
  name: 'OrderCheckList',
  components: {
    DialogDepartment
  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private isCheckSettingGroup = false;
  private groupType = GroupType.GROUP_DEPARTMENT_CHECK;
  
  private formSearch:any = {};
  private tableData:any = [];

  private departmentVisible = false;
  private isCheckboxDept = true
  private deptType = -1
  private listLoading = false;

  private stateOptions=[{
    name: '启用',
    id: '1'
  }, { name: '未启用',
    id: '0' }]

  created() {

    this.isCheckSettingGroup = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CheckSettingGroup);
    this.groupType = this.isCheckSettingGroup ?  GroupType.GROUP_CHECK :  GroupType.GROUP_DEPARTMENT_CHECK;

    this.groupCsList();
    this.getDepartmentList();

  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.groupCsList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.groupCsList();
  }
  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.groupCsList();
  }

  // 清空
  private handleSearchClear() {
    this.formSearch = {};
    this.pagination.currentPage = 1;
    this.groupCsList();
  }
  private deptmentOptions:any=[]
  private getDepartmentList() {
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: 1,
      size: 999
    };

    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          this.deptmentOptions = res.data.list;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private groupCsList() {
    this.listLoading = true;
    const params:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.formSearch.group_name) {
      params.group_name = this.formSearch.group_name;
    }
    if (this.formSearch.deptment) {
      params.dept_id = this.formSearch.deptment.dept_id;
    }
    if (this.formSearch.state && this.formSearch.state.name) {
      params.state = this.formSearch.state.id;
    }
    params.group_type = this.groupType;
    groupCsList(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        for (let index = 0; index < res.data.list.length; index++) {
          const element = res.data.list[index];
          if (element.department_list && element.department_list.length > 0) {
            res.data.list[index].deptNameLocShow = element.department_list[0].department_name;
            res.data.list[index].deptLocListShow = element.department_list.slice(1);
          }
        }
        this.tableData = res.data.list;
        this.pagination.total = res.data.count;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      this.tableData = [];
      this.pagination.total = 0;
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  private editData: any;
  private isBatch=0

  private groupHandle(val:any, isBatch:any) {
    //部门审核群组的新建编辑
    if(GroupType.GROUP_DEPARTMENT_CHECK == this.groupType ){
      this.isBatch = isBatch || '0'
      if (val) {
        this.editData = val;
        if (parseInt(val.is_default_group) === 1) {
          this.$prompt('名称', '群组名称', {
            confirmButtonText: '完成',
            cancelButtonText: '取消',
            inputErrorMessage: '请输入1-30位的名称',
            inputPlaceholder: '请输入群组名称(不超过30字)',
            inputPattern: /^\S.{0,29}$/,
            inputValue: (this.editData && this.editData.group_name) ? this.editData.group_name : ''
          }).then(({ value }: any) => {
            this.addAndEdit(value, '1');
          }).catch(() => {
          });
        } else {
          this.checkBoxSelect = val.department_list;
          for (let index = 0; index < this.checkBoxSelect.length; index++) {
            this.checkBoxSelect[index].dept_id = this.checkBoxSelect[index].department_id;
            this.checkBoxSelect[index].name = this.checkBoxSelect[index].department_name;
          }
          this.departmentVisible = true;
        }
      } else {
        // alert("新建")
        this.checkBoxSelect = []
        this.departmentVisible = true
        this.editData = {}
      }
    }else{
      //分组审核群组的新建编辑
      let is_default_group = '0';
      if (val) {
        this.editData = val;
        if (parseInt(val.is_default_group) === 1) {
          is_default_group = val.is_default_group;
        }
      }
      this.$prompt('名称', '群组名称', {
        confirmButtonText: '完成',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入1-30位的名称',
        inputPlaceholder: '请输入群组名称(不超过30字)',
        inputPattern: /^\S.{0,29}$/,
        inputValue: (this.editData && this.editData.group_name) ? this.editData.group_name : ''
      }).then(({ value }: any) => {
      
        this.addAndEdit(value,is_default_group  );
      }).catch(() => {
      });
    }
  }

  private addGroupDefaultHandle() {
    this.editData = {};
    this.$prompt('名称', '群组名称', {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      inputErrorMessage: '请输入1-30位的名称',
      inputPlaceholder: '请输入群组名称(不超过30字)',
      inputPattern: /^\S.{0,29}$/,
      inputValue: ''
    }).then(({ value }: any) => {
      this.addAndEdit(value, '1');
    }).catch(() => {
    });
  }

  private checkBoxSelect:any=[]
  private departmentSelected(val: any) {
    this.checkBoxSelect = val;
  }
  private finishHandle() {
    //如果部门审核检查是否设置了部门
    if(GroupType.GROUP_DEPARTMENT_CHECK == this.groupType ){
      if (this.checkBoxSelect.length <= 0) {
        this.showErrorMsg("请选择部门")
        return
      }
    }
    if (this.isBatch !== 1) {
      this.$prompt('名称', '群组名称', {
        confirmButtonText: '完成',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入1-30位的名称',
        inputPlaceholder: '请输入群组名称(不超过30字)',
        inputPattern: /^\S.{0,29}$/,
        inputValue: (this.editData && this.editData.group_name) ? this.editData.group_name : ''
      }).then(({ value }: any) => {
        this.addAndEdit(value, (this.editData && this.editData.is_default_group) ? this.editData.is_default_group : '0');
      }).catch(() => {
      });
    } else {
      this.batchAddCheckGroup()
    }
  }
  private batchAddCheckGroup() {
    let pamarms:any = {};
    pamarms.user_id = UserModule.getUserId;
    pamarms.company_id = UserModule.getCompanyId;
    if (this.checkBoxSelect.length > 0) {
      let arr = [];
      for (let index = 0; index < this.checkBoxSelect.length; index++) {
        const element:any = this.checkBoxSelect[index];
        let dept:any = {};
        dept.id = element.dept_id;
        dept.name = element.name;
        arr.push(dept);
      }
      pamarms.department = JSON.stringify(arr);
    }
    batchAddCheckGroup(pamarms).then((res:any) => {
      this.departmentVisible = false;
      this.showSuccessMsg(res.msg);
      this.groupCsList();
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private addAndEdit(val:string, isDefult:string) {
    let pamarms:any = {};
    pamarms.user_id = UserModule.getUserId;
    pamarms.company_id = UserModule.getCompanyId;
    pamarms.group_type = this.groupType;
    pamarms.group_name = val;
    pamarms.is_default_group = isDefult;

    //部门审核群组的新建编辑
    if(GroupType.GROUP_DEPARTMENT_CHECK == this.groupType ){
      if (this.checkBoxSelect.length > 0) {
        let arr = [];
        for (let index = 0; index < this.checkBoxSelect.length; index++) {
          const element:any = this.checkBoxSelect[index];
          let dept:any = {};
          dept.id = element.dept_id;
          dept.name = element.name;
          arr.push(dept);
        }
        pamarms.department = JSON.stringify(arr);
      }else{
        this.showErrorMsg("请选择部门")
        return
      }
    }
    if (this.editData && this.editData.id) {
      pamarms.group_id = this.editData.id;
      editGroupCs(pamarms).then((res:any) => {
        this.departmentVisible = false;
        this.showSuccessMsg(res.msg);
        this.groupCsList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addGroupCs(pamarms).then((res:any) => {
        this.departmentVisible = false;
        this.showSuccessMsg(res.msg);
        this.groupCsList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private departmentDialogClose() {
    this.departmentVisible = false;
  }

  private settingHandle(val:any) {
    // /OrderCheckSet
    if (this.$route.path === '/OrderCheckSet') {
      this.$router.push({
        path: '/setCheckOrder',
        query: val
      });
    } else {
      this.$router.push({
        path: 'setCheckOrder',
        query: val
      });
    }
  }

  private deleteGroupHandle(val: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          group_id: val.id
        };
        delGroupCs(params).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.groupCsList();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
